import { IconLayoutKanban, IconTable } from "@tabler/icons-react";
import { Grid, Segmented } from "antd";
import { useState } from "react";
import { CustomIcon } from "./base";
import { KanbanBoard, type KanbanConfig } from "./kanban-board";
import { ResponsiveTable, type ResponsiveTableProps } from "./responsive-table";

export interface ResponsiveTableKanbanProps<TData, TKey extends string>
	extends ResponsiveTableProps<TData> {
	kanban: KanbanConfig<TData, TKey>;
}

type View = "table" | "kanban";

/** ResponsiveTable with a table/kanban switch. Kanban is desktop-only — on mobile the switch is hidden and the compact list is shown. */
export function ResponsiveTableKanban<
	TData extends object,
	TKey extends string,
>({
	kanban,
	toolbarActions,
	...props
}: ResponsiveTableKanbanProps<TData, TKey>) {
	const screens = Grid.useBreakpoint();
	const [view, setView] = useState<View>("table");

	return (
		<ResponsiveTable<TData>
			{...props}
			toolbarActions={
				<>
					{screens.lg && (
						<Segmented<View>
							value={view}
							onChange={setView}
							options={[
								{
									value: "table",
									label: (
										<CustomIcon
											icon={IconTable}
											size={16}
											style={{ verticalAlign: "middle" }}
										/>
									),
									title: "Table",
								},
								{
									value: "kanban",
									label: (
										<CustomIcon
											icon={IconLayoutKanban}
											size={16}
											style={{ verticalAlign: "middle" }}
										/>
									),
									title: "Kanban",
								},
							]}
						/>
					)}
					{toolbarActions}
				</>
			}
			renderBody={
				view === "kanban"
					? (rows, footer) => (
							<KanbanBoard
								rows={rows}
								footer={footer}
								config={kanban}
								onCardClick={props.onRowClick}
							/>
						)
					: undefined
			}
		/>
	);
}
